import SelectableProceduresListItem from './SelectableProceduresListItem';

export default SelectableProceduresListItem;
